import MomentUtils from '@date-io/moment'
import moment from 'moment-timezone'
import { dispatch } from 'store'
import { DEFAULT_TIME_ZONE, locationTimeZone } from 'cf-models-restaurant/src/plugin/timezone'

export default class PickerMomentUtils extends MomentUtils {
  getTimeZone() {
    return dispatch.restaurant.getTimeZone()
  }

  date(value) {
    if (value === null) return null
    const result = moment.tz(value, this.getTimeZone())
    if (this.locale) result.locale(this.locale)
    return result
  }

  parse(value, format) {
    return value === '' ? null : moment.tz(value, format, true, this.getTimeZone())
  }
}

export class ReportingPickerMomentUtils extends PickerMomentUtils {
  getTimeZone() {
    return DEFAULT_TIME_ZONE
  }
}

// The locations list can edit a location other than the currently selected one.
export function pickerUtilsForZone(timeZone) {
  return class extends PickerMomentUtils {
    getTimeZone() {
      return locationTimeZone({ timeZone })
    }
  }
}
